import { render, staticRenderFns } from "./TimelinePoint.vue?vue&type=template&id=6504f14f&scoped=true"
import script from "./TimelinePoint.vue?vue&type=script&lang=js"
export * from "./TimelinePoint.vue?vue&type=script&lang=js"
import style0 from "./TimelinePoint.vue?vue&type=style&index=0&id=6504f14f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6504f14f",
  null
  
)

export default component.exports